var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "full-height bg-white relative-position" },
    [
      _c("q-card-title", { staticClass: "text-center bg-primary text-white" }, [
        _vm._v("\n        " + _vm._s(_vm.$t("my_score")) + "\n    ")
      ]),
      _c("q-card-separator"),
      _c(
        "q-card-main",
        {
          staticClass: "text-center",
          class: !_vm.home ? "q-my-md" : "q-mt-md"
        },
        [
          _c("q-knob", {
            staticStyle: { "font-size": "2rem" },
            attrs: {
              value: _vm.getScore(_vm.score),
              max: _vm.maxScore,
              color: "primary",
              size: "60%",
              readonly: ""
            }
          })
        ],
        1
      ),
      _c(
        "q-card-actions",
        { staticClass: "justify-center", class: !_vm.home ? "q-mt-lg" : "" },
        [
          _vm.score_statement && _vm.score_statement.length > 0
            ? _c(
                "q-list",
                { attrs: { "no-border": "", separator: "", dense: "" } },
                [
                  _c(
                    "q-item",
                    [
                      _c("q-item-main", [
                        _c(
                          "span",
                          {
                            staticClass: "cursor-pointer text-faded",
                            on: {
                              click: function($event) {
                                return _vm.showStatement()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("see_statement")))]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "q-inner-loading",
        { attrs: { visible: _vm.score == null } },
        [_c("q-spinner-dots", { attrs: { size: 60, color: "secondary" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }